import { create } from 'zustand';
import type { AuthState, User, UserRole } from '@/types/user.types';
import { authService } from '@/services/auth.service';

export const useAuthStore = create<AuthState>((set, get) => {
  // Initialize from localStorage
  const { token, user } = authService.getAuthData();

  return {
    user,
    token,
    isAuthenticated: !!token,

    login: (token: string, user: User, refreshToken?: string) => {
      authService.saveAuthData(token, user, refreshToken);
      set({
        user,
        token,
        isAuthenticated: true,
      });
    },

    logout: () => {
      authService.clearAuthData();
      set({
        user: null,
        token: null,
        isAuthenticated: false,
      });
    },

    isAdmin: () => get().user?.role === 'admin',
    isSubAdmin: () => get().user?.role === 'sub_admin',
    isOperator: () => get().user?.role === 'operator',
    hasRole: (roles: UserRole[]) => {
      const r = get().user?.role;
      return r ? roles.includes(r) : false;
    },
    canManageUsers: () => ['admin', 'sub_admin'].includes(get().user?.role ?? ''),
    canManageGroups: () => get().user?.role === 'admin',
  };
});
